import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { IoArrowBackOutline, IoDocumentTextOutline, IoHardwareChipOutline, IoStatsChartOutline, IoTrashOutline, IoPencilOutline, IoAddCircleOutline } from 'react-icons/io5';
import Navbar from '../lab/Navbar';
import labService from '../lab/labService';
import '../wallet/css/ManageLicences.css';

const ManageModelDetails = () => {
  const { modelId } = useParams();
  const navigate = useNavigate();
  const [model, setModel] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchModelDetails = async () => {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      if (!token) return;
      try {
        const response = await labService.getModelDetailsAdmin(modelId, token);
        setModel(response.data);
      } catch (error) {
        console.error("Błąd pobierania szczegółów:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchModelDetails();
  }, [modelId]);

  const handleDelete = async () => {
    if (window.confirm(`Are you sure you want to delete model: ${model.model_name}?`)) {
      const token = JSON.parse(localStorage.getItem('user'))?.access;
      try {
        await labService.deleteModelAdmin(modelId, token);
        navigate('/manage-models');
      } catch (error) {
        alert("Failed to delete model. Check if URL is correct (API_URL_AUTH).");
      }
    }
  };

  if (isLoading) return <div className="spinner"></div>;

  if (!model) return <div>Model not found</div>;

  const stats = model.model_details?.statistics || {};
  const descriptorsList = model.descriptors?.descriptors || [];
  const descriptorsUnits = model.descriptors?.descriptors_units || [];
  // ----------------------------------

  return (
    <div className='lab-container'>
      <Navbar />
      <div className="manage-licenses-container" style={{ padding: '40px' }}>
        <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>

          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <IoArrowBackOutline
              style={{ fontSize: '32px', cursor: 'pointer', color: '#1B4480' }}
              onClick={() => navigate(-1)}
            />
            <div>
              <div style={{ color: '#718096', fontSize: '0.9rem', textTransform: 'uppercase', fontWeight: 'bold' }}>
                {model.endpoint_name || 'General'} / {model.version_name}
              </div>
              <h2 className='h2-title' style={{ margin: 0, color: '#1B4480' }}>
                {model.model_name}
              </h2>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px' }}>
            <button className="btn btn-danger" onClick={handleDelete}>
              <IoTrashOutline size="18px" /> Delete model
            </button>

            <button className="btn btn-primary" onClick={() => navigate(`/manage-models/${modelId}/edit`)}>
              <IoPencilOutline size="18px" /> Modify model
            </button>

            <button
              className="btn btn-neutral"
              onClick={() => navigate(`/manage-models/${modelId}/new-version`)}
            >
              <IoAddCircleOutline size="18px" /> New version
            </button>
          </div>
        </header>

        <div style={{ display: 'flex', gap: '10px', marginBottom: '30px' }}>
          <span style={{ padding: '6px 12px', backgroundColor: '#e6fffa', borderRadius: '6px', fontWeight: 'bold', color: '#285e61', textTransform: 'capitalize' }}>
            {model.model_category}
          </span>
          <span style={{ padding: '6px 12px', backgroundColor: '#ebf4ff', borderRadius: '6px', fontWeight: 'bold', color: '#2b6cb0', textTransform: 'capitalize' }}>
            {model.method_type}
          </span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '30px' }}>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '25px' }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#1B4480', marginTop: 0 }}>
                <IoDocumentTextOutline /> Description
              </h3>
              <p style={{ color: '#4a5568', lineHeight: '1.6' }}>{model.model_details?.endpoint_desc || model.model_description || 'No description provided.'}</p>

              <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f7fafc', borderRadius: '6px' }}>
                <strong style={{ color: '#2d3748' }}>Applicability Domain:</strong>
                <p style={{ margin: '5px 0 0 0', color: '#4a5568', fontSize: '0.95rem' }}>{model.model_details?.model_applicability || 'N/A'}</p>
              </div>
            </div>

            <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '25px' }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#1B4480', marginTop: 0 }}>
                <IoHardwareChipOutline /> Required Descriptors
              </h3>
              <p style={{ color: '#718096', fontSize: '0.9rem', marginBottom: '15px' }}>{model.model_details?.descriptors_desc}</p>

              {descriptorsList.length > 0 ? (
                <ul style={{ listStyleType: 'none', padding: 0, margin: 0, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                  {descriptorsList.map((desc, index) => (
                    <li key={index} style={{ padding: '10px', backgroundColor: '#edf2f7', borderRadius: '6px', fontSize: '0.9rem', color: '#2d3748' }}>
                      <strong>{desc}</strong>
                      {descriptorsUnits[index] && <span style={{ color: '#718096', marginLeft: '5px' }}>({descriptorsUnits[index]})</span>}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No descriptors defined.</p>
              )}
            </div>

          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

            <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '25px' }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#1B4480', marginTop: 0 }}>
                <IoStatsChartOutline /> Performance
              </h3>
              {Object.keys(stats).length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {Object.entries(stats).map(([key, value]) => (
                    <div key={key} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #edf2f7', paddingBottom: '8px' }}>
                      <span style={{ color: '#4a5568' }}>{key}</span>
                      <strong style={{ color: '#1B4480' }}>{value}</strong>
                    </div>
                  ))}
                </div>
              ) : (
                <p>No statistics available.</p>
              )}
            </div>

            <div style={{ backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '25px' }}>
              <h3 style={{ color: '#1B4480', marginTop: 0, marginBottom: '15px' }}>Technical Specs</h3>
              <div style={{ fontSize: '0.85rem', color: '#4a5568', wordBreak: 'break-all' }}>
                <p><strong>Algorithm:</strong><br />{model.algorithm_type}</p>
                <p><strong>Response Class:</strong><br />{model.response_class}</p>
                <p><strong>Model Exec:</strong><br />{model.model_exec_path}</p>
                {model.model_details?.qmrf_filename && (
                  <p><strong>QMRF Document:</strong><br />{model.model_details.qmrf_filename}</p>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageModelDetails;
